import axios from 'axios';
import { getApiHost } from '@hotjar/common';
import type { ApiBaseResponse } from '@hotjar/webapp/domains/common/api';
import type { Site } from '@hotjar/site';
import type { Settings } from '@hotjar/webapp/domains/common/settings';
import type { GTMAccount, GTMContainer, GTMAccounts, GTMContainers } from './model';

export const getAccounts = async (site: Site): Promise<GTMAccount[]> => {
  const response = await axios.post<GTMAccounts>(`/api/v1/sites/${site.id}/integrations/gtm`, {
    action: 'get_accounts',
  });
  return response.data.accounts;
};

export const getContainers = async (
  site: Site,
  gtmAccount: GTMAccount,
): Promise<GTMContainer[]> => {
  const response = await axios.post<GTMContainers>(`/api/v1/sites/${site.id}/integrations/gtm`, {
    action: 'get_containers',
    account_id: gtmAccount.accountId,
  });
  return response.data.containers;
};

export const createAndPublishTag = async (
  site: Site,
  gtmAccount: GTMAccount,
  gtmContainer: GTMContainer,
): Promise<ApiBaseResponse> => {
  const response = await axios.post<ApiBaseResponse>(`/api/v1/sites/${site.id}/integrations/gtm`, {
    action: 'create_and_publish_tag',
    account_id: gtmAccount.accountId,
    container_id: gtmContainer.containerId,
  });

  if (!response.data.success) {
    throw new Error('Failed to publush tag');
  }

  return response.data;
};

export const getOAuthURL = (site: Site, user: { id: number }, settings: Settings): string => {
  if (!settings?.apis?.gtm) {
    return '';
  }
  const redirectURL = encodeURIComponent(
    `${getApiHost()}/api/v1/settings/integrations/gtm-callback`,
  );
  const state = encodeURIComponent(`${site.id},${user.id},${window.location.pathname}`);
  const scope = encodeURIComponent(settings?.apis.gtm.scopes);
  const clientId = encodeURIComponent(settings?.apis.gtm.client_id);
  return `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectURL}&response_type=code&state=${state}&prompt=consent&scope=${scope}`;
};

export const checkGTMSetup = async (site: Site): Promise<ApiBaseResponse> => {
  const response = await axios.get<ApiBaseResponse>(
    `/api/v1/accounts/${site.account.id}/sites/${site.id}/gtm-check`,
  );

  return response.data;
};
